import { render, staticRenderFns } from "./mvAuthorityEdit.vue?vue&type=template&id=df6c7700&scoped=true"
import script from "./mvAuthorityEdit.vue?vue&type=script&lang=js"
export * from "./mvAuthorityEdit.vue?vue&type=script&lang=js"
import style0 from "./mvAuthorityEdit.vue?vue&type=style&index=0&id=df6c7700&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "df6c7700",
  null
  
)

export default component.exports